<template>
  <div class="orderuploadInvoice">
        <el-dialog 
            :visible.sync="onShow" 
            width="710px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            z-index="5"
            center 
        >
            <div class="onDehalf-title mb-2">
                <div>{{orderDetail.title}}_发票上传</div>
                <!--关闭-->
                <span class="close" @click="$emit('onShow');picImgs=lnvoiceImgs;"><i class="el-icon-close"></i></span>
            </div>
            <upload-image class="mt-4 mb-2 upload" :hotel_title="orderDetail.title"  @fileChange="(imgs)=>{picImgs = imgs;}" :existImgs="picImgs" :maxLength="10" :editMode="editMode" :pdfMode="true" acceptType="image/*,.pdf"/>
            <div  class="onDehalf-bottoms">
                <el-button @click="$emit('onShow');picImgs=lnvoiceImgs;">返 回</el-button>
                <el-button v-if="editMode"  type="primary" @click="submitForm('formLabelAlign')">保 存</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { UploadImages } from '@/assets/utils/uploadFiles'
import { data } from 'jquery';
import { mapState,mapActions} from 'vuex'
export default {
  name: 'OrderuploadInvoice',
  components: {},   
  props: {
        orderDetail: {
            type: Object,
            default: () => {}
        },
        onShow: {
            type: Boolean,
            default: false
        },
        editMode: {
            type: Boolean,
            default: false
        },
        existImgs: {
            type: String,
            default: ''
        },
        invoiceType:{}
  },
  data() {
    return {
        picImgs: [],
        lnvoiceImgs: [],                //副图片列表
    };
  },
  computed: {},
  watch: {
    existImgs: {
        async handler(newVal, oldVal) {
            if(newVal){
                let picImgs=newVal.split(',').map(async item=>{
                    const format = await this.POST_GetQiNiuFileExt({key:item});
                    return{
                        url:item,
                        type:format,
                    };
                })
                picImgs = await Promise.all(picImgs);
                this.picImgs=picImgs;
                this.lnvoiceImgs=JSON.parse(JSON.stringify(picImgs));
                this.$emit('onShow')
                this.$emit('isClick')
            }
        },
        immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_EditOrderHotelDeposit','POST_GetQiNiuFileExt','POST_SendEditReceipt']),
    //代订收款短信通知
    async submitForm() {
        this.$emit('onShow');
        let _this=this;
        let picImgs=this.picImgs.map(item=>item.url);
        let src = await UploadImages(picImgs,true)                     //外观图片
        this.POST_SendEditReceipt({
                data:{url:src,oid:this.orderDetail.oid},
                type:this.invoiceType,
                successFun(res){
                    _this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    _this.lnvoiceImgs=[];
                    _this.$emit('getorderDetail')
                }
            })

    },
  }
};
</script>

<style lang="scss" scoped>
    .onDehalf-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        text-align: center;
        position: relative;
    }
    .noHint{
        text-align: center;
        margin-top: 20px;
        .img{
            width: 200px;
        }
        p{
            margin-top: 14px;
            color:#999
        }
    }
    .close{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #999;
        background-color: #f3f4f8;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;
    }
    .onDehalf-bottoms{
        display: flex;
        justify-content:flex-end;
    }
</style>
<style >
    .orderuploadInvoice .el-dialog__header{
        padding: 0 !important;
    }
</style>